import './footer.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone, faMapMarkerAlt, faShieldAlt, faLock } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import logo from '../header/images/logo.png';

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [newsletterSubmitted, setNewsletterSubmitted] = useState(false);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email) {
      // Aici ar fi logica de trimitere la backend
      setNewsletterSubmitted(true);
      setTimeout(() => {
        setEmail('');
        setNewsletterSubmitted(false);
      }, 3000);
    }
  };

  return (
    <footer className='footer-modern'>
      <div className='footer-content'>
        {/* Column 1: Logo & About */}
        <div className='footer-column footer-about'>
          <div className='footer-logo'>
            <img src={logo} alt='ContaLearn Logo' className='footer-logo-image' />
          </div>
          <p className='footer-description'>
            Platforma ta completa pentru invatarea contabilitatii. Cursuri interactive, 
            jocuri educationale si certificare recunoscuta.
          </p>
          <div className='footer-trust-badges'>
            <div className='trust-badge'>
              <FontAwesomeIcon icon={faShieldAlt} />
              <span>GDPR</span>
            </div>
            <div className='trust-badge'>
              <FontAwesomeIcon icon={faLock} />
              <span>SSL</span>
            </div>
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div className='footer-column'>
          <h4 className='footer-column-title'>Navigare Rapida</h4>
          <ul className='footer-links'>
            <li><Link to='/'>Home</Link></li>
            <li><Link to='/about'>Despre Noi</Link></li>
            <li><Link to='/cursuri-prezentare'>Cursuri</Link></li>
            <li><Link to='/jocuri-prezentare'>Jocuri</Link></li>
            <li><Link to='/FAQ'>Intrebari Frecvente</Link></li>
            <li><Link to='/ajutor'>Contact</Link></li>
            <li><Link to='/cariere'>Cariere</Link></li>
          </ul>
        </div>

        {/* Column 3: Legal */}
        <div className='footer-column'>
          <h4 className='footer-column-title'>Legal</h4>
          <ul className='footer-links'>
            <li><Link to='/Termeni'>Termeni si Conditii</Link></li>
            <li><Link to='/Politica'>Politica de Confidentialitate</Link></li>
            <li><Link to='/Politicacookies'>Politica de Cookie-uri</Link></li>
            <li><Link to='/gdpr'>Protectia Datelor</Link></li>
            <li><Link to='/anpc'>Protectia Consumatorului</Link></li>
          </ul>
        </div>

        {/* Column 4: Contact & Newsletter */}
        <div className='footer-column footer-contact'>
          <h4 className='footer-column-title'>Contact</h4>
          <div className='footer-contact-info'>
            <div className='contact-item'>
              <FontAwesomeIcon icon={faEnvelope} />
              <a href='mailto:contact@contalearn.ro'>contact@contalearn.ro</a>
            </div>
            <div className='contact-item'>
              <FontAwesomeIcon icon={faPhone} />
              <span>+40 XXX XXX XXX</span>
            </div>
            <div className='contact-item'>
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <span>Romania</span>
            </div>
          </div>

          <div className='footer-newsletter'>
            <h5>Newsletter</h5>
            <p>Primeste noutati si oferte exclusive</p>
            {!newsletterSubmitted ? (
              <form onSubmit={handleNewsletterSubmit} className='newsletter-form'>
                <input
                  type='email'
                  placeholder='Email-ul tau'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type='submit'>Aboneaza-te</button>
              </form>
            ) : (
              <div className='newsletter-success'>
                ✓ Te-ai abonat cu succes!
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Social Media & Bottom Bar */}
      <div className='footer-bottom'>
        <div className='footer-bottom-content'>
          <div className='footer-social'>
            <a href='https://www.facebook.com/profile.php?id=61566996040137' target='_blank' rel='noopener noreferrer' className='social-link social-facebook'>
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href='https://www.instagram.com/conta_learn/' target='_blank' rel='noopener noreferrer' className='social-link social-instagram'>
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href='https://www.linkedin.com/company/contalearn' target='_blank' rel='noopener noreferrer' className='social-link social-linkedin'>
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
          </div>
          
          <div className='footer-copyright'>
            <p>© 2025 Toate drepturile rezervate. <Link to='/' className='footer-brand-link'>ContaLearn.ro</Link></p>
          </div>

          <div className='footer-made-with'>
            <p>Made with ❤️ in Romania</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
